import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "flowbite";

import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import GetInTouch from "./pages/GetInTouch";
import NotFound from "./pages/NotFound";
// import Chat from "./pages/Chat";
import Discovery from "./pages/Discovery";
// import DemoPaymentConfirmation from "./pages/DemoPaymentConfirmation";
import ScrollToTop from "./components/ScrollToTop";
import BlogListing from "./pages/BlogHome";
import DynamicBlog from './pages/DynamicBlog';
import MumbaiZingDemo from "./pages/client-demos/mumbai-zing";

import { HelmetProvider } from "react-helmet-async";
import AppointmentConfirmation from "./pages/AppointmentConfirmation";
import Appointment from "./pages/Appointment";
import Network from "./pages/Network";
import NetworkQrGenerator from "./pages/NetworkQrGenerator";
import HoldingScreen from "./pages/client-demos/HoldingScreen";
import DigitalConnectPricing from "./pages/dev/DigitalConnectPricing";
import Trademark from "./pages/Trademark";
import Journey from "./pages/Journey";
import DigitalConnect from "./pages/DigitalConnect"

import Convu from "./pages/Convu";
import ConvuConfirmation from "./pages/ConvuConfirmation";

// Arkana Rama
import MargaretDigitalCard from "./pages/arkana-rama/margaret"
import MargaretQrGenerator from "./pages/arkana-rama/margaret-qr-generator"

import MarcDigitalCard from "./pages/arkana-rama/marc"
import MarcQrGenerator from "./pages/arkana-rama/marc-qr-generator"

import ArunDigitalCard from "./pages/arkana-rama/arun"
import ArunQrGenerator from "./pages/arkana-rama/arun-qr-generator"

import MoDigitalCard from "./pages/arkana-rama/mo"
import MoQrGenerator from "./pages/arkana-rama/mo-qr-generator"

// Aria Grace
import EzanaDigitalCard from "./pages/aria-grace/ezana"
import EzanaQrGenerator from "./pages/aria-grace/ezana-qr-generator"

// import Login from "./pages/dev/Login";
// import UserDashboard from "./pages/dev/UserDashboard";

function App() {
  // useEffect(() => {
  //   console.log("🔍 Using API base:", process.env.REACT_APP_API_BASE_URL);

  //   fetch(`${process.env.REACT_APP_API_BASE_URL}/hello`)
  //     .then(res => res.json())
  //     .then(data => console.log('✅ Backend says:', data))
  //     .catch(err => console.error('❌ API error:', err));
  // }, []);

  return (
    <Router>
      <HelmetProvider>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/get-in-touch" element={<GetInTouch />} />
            <Route path="/discovery" element={<Discovery />} />
            <Route path="/appointment-confirmation" element={<AppointmentConfirmation />} />
            <Route path="/appointment" element={<Appointment />} />
            <Route path="/contact" element={<Network />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/trademark" element={<Trademark />} />
            <Route path="/journey" element={<Journey />} />
            <Route path="/digital-connect" element={<DigitalConnect />} />

            <Route path="/convu" element={<Convu />} />
            <Route path="/convu-confirmation" element={<ConvuConfirmation />} />

            <Route path="/network" element={<Network />} />
            <Route path="/network-qr-generator" element={<NetworkQrGenerator />} />

            {/* <Route path="/demo-payment-confirmation" element={<DemoPaymentConfirmation />} /> */}
            {/* <Route path="/chat" element={<Chat />} /> */}

            {/* QR Codes */}
            <Route path="/qr/hoodie" element={<Navigate to="/get-in-touch" replace />} />
            <Route path="/whatsapp-assistant" element={<Navigate to="https://api.whatsapp.com/send/?phone=447447164108&text=Hi%20DataPulse!%20%F0%9F%91%8B%F0%9F%8F%BD%20I%27m%20interested%20in%20how%20you%20can%20help%20grow%20my%20business%20%F0%9F%9A%80" replace />}/>

            {/* Client Demos */}
            <Route path="/demo/development" element={<HoldingScreen />} />
            <Route path="/demo/mumbai-zing" element={<MumbaiZingDemo />} />

            {/* Blog */}
            <Route path="/blog" element={<BlogListing />} />
            <Route path="/blog/:slug" element={<DynamicBlog />} />

            {/* Dev */}
            {/* <Route path="/dev/login" element={<Login />} />
            <Route path="/dev/user-dashboard" element={<UserDashboard />} /> */}
            <Route path="/dev/the-digital-connect" element={<DigitalConnectPricing />} />

            {/* Arkana Rama */}
            <Route path="/arkana-rama/margaret" element={<MargaretDigitalCard />} />
            <Route path="/arkana-rama/margaret-qr-generator" element={<MargaretQrGenerator />} />

            <Route path="/arkana-rama/marc" element={<MarcDigitalCard />} />
            <Route path="/arkana-rama/marc-qr-generator" element={<MarcQrGenerator />} />

            <Route path="/arkana-rama/arun" element={<ArunDigitalCard />} />
            <Route path="/arkana-rama/arun-qr-generator" element={<ArunQrGenerator />} />

            <Route path="/arkana-rama/mo" element={<MoDigitalCard />} />
            <Route path="/arkana-rama/mo-qr-generator" element={<MoQrGenerator />} />

            {/* Arkana Rama */}
            <Route path="/aria-grace/ezana" element={<EzanaDigitalCard />} />
            <Route path="/aria-grace/ezana-qr-generator" element={<EzanaQrGenerator />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </HelmetProvider>
    </Router>
  );
}

export default App;

